import { render } from "./ManageOrderView.vue?vue&type=template&id=24f71ed8&scoped=true&ts=true"
import script from "./ManageOrderView.vue?vue&type=script&lang=ts"
export * from "./ManageOrderView.vue?vue&type=script&lang=ts"

import "./ManageOrderView.vue?vue&type=style&index=0&id=24f71ed8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f71ed8"]])

export default __exports__